



export const NEWLEAVEREQUESTCREATE = "NEWLEAVEREQUESTCREATE"
export const NEWLEAVEREQUESTCREATE_SUCCESS = "NEWLEAVEREQUESTCREATE_SUCCESS"
export const NEWLEAVEREQUESTCREATE_FAIL = "NEWLEAVEREQUESTCREATE_FAIL"

export const GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS = "GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS"
export const GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_SUCCESS = "GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_SUCCESS"
export const GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_FAIL = "GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_FAIL"

export const UPDATE_NEWLEAVESHAREREQUEST_REQUEST = "UPDATE_NEWLEAVESHAREREQUEST_REQUEST"
export const UPDATE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS = "UPDATE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS"
export const UPDATE_NEWLEAVESHAREREQUEST_REQUEST_FAIL = "UPDATE_NEWLEAVESHAREREQUEST_REQUEST_FAIL"

export const DELETE_NEWLEAVESHAREREQUEST_REQUEST = "DELETE_NEWLEAVESHAREREQUEST_REQUEST"
export const DELETE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS = "DELETE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS"
export const DELETE_NEWLEAVESHAREREQUEST_REQUEST_FAIL = "DELETE_NEWLEAVESHAREREQUEST_REQUEST_FAI"

export const Get_Audit_Trail = "Get_Audit_Trail"
export const Get_Audit_Trail_Success = "Get_Audit_Trail_Success"
export const Get_Audit_Trail_Fail = "Get_Audit_Trail_Fail"

export const Get_Audit_Trail_History = "Get_Audit_Trail_History"
export const Get_Audit_Trail_Success_History = "Get_Audit_Trail_Success_History"
export const Get_Audit_Trail_Fail_History = "Get_Audit_Trail_Fail_History"
